import { render, staticRenderFns } from "./subinfo.vue?vue&type=template&id=69dcbff1&"
import script from "./subinfo.vue?vue&type=script&lang=js&"
export * from "./subinfo.vue?vue&type=script&lang=js&"
import style0 from "./subinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports